import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getEnvVariables } from '../../helpers/getEnvVariables';
const { REACT_APP_URL } = getEnvVariables();

export const sessionApi = createApi({
    reducerPath: 'session',
    baseQuery: fetchBaseQuery({ baseUrl: REACT_APP_URL }),
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: "customer/login",
                method: 'POST',
                body: data,
            }),
        }),
        logout: builder.mutation({
            query: (token: string) => ({
                url: `customer/logout/${token}`,
                method: 'DELETE',
                headers: new Headers({ 'Authorization': token }),
            }),

        }),

    }),
});

export const { useLoginMutation, useLogoutMutation } = sessionApi;